import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./filter-by.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./filter-by.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { AppControllerService } from "../../../app-controller.service";
import { AlertType } from "../../models/alert";
import { SharedConstants } from "../../constants/shared.constants";
let FilterByComponent = class FilterByComponent {
    changeDetectorRef;
    appControllerService;
    filterByOptions;
    filterByChanged = new EventEmitter();
    filterTextChanged = new EventEmitter();
    pageName;
    initialFilterText;
    initialFilterColumn;
    label = SharedConstants.FILTER_PREFIX;
    filterTextPlaceHolder;
    filterText;
    dropDownValue;
    dropDownPlaceHolder = SharedConstants.FILTER_BY_PLACEHOLDER;
    dropDownDefault = SharedConstants.FILTER_BY_DEFAULT;
    constructor(changeDetectorRef, appControllerService) {
        this.changeDetectorRef = changeDetectorRef;
        this.appControllerService = appControllerService;
    }
    ngOnInit() {
        this.filterText = this.initialFilterText;
        this.addFilterByDefault();
        this.initializePlaceHolder();
        if (this.initialFilterColumn) {
            this.dropDownDefault = this.initialFilterColumn;
            this.dropDownValue = this.initialFilterColumn;
        }
        else {
            this.dropDownValue = this.dropDownDefault;
        }
    }
    filterChanged($event) {
        this.dropDownValue = $event;
        this.filterByChanged.emit({
            text: this.filterText || "",
            column: this.dropDownValue
        });
        this.changeDetectorRef.markForCheck();
    }
    textChanged($event) {
        this.filterText = $event;
        if (this.dropDownValue === this.dropDownPlaceHolder) {
            this.appControllerService.showMessage(SharedConstants.NO_FILTER_SELECTED_MESSAGE, AlertType.Warning);
            return;
        }
        this.filterTextChanged.emit({ text: $event, column: this.dropDownValue });
        this.changeDetectorRef.markForCheck();
    }
    addFilterByDefault() {
        if (this.filterByOptions && this.filterByOptions.indexOf(SharedConstants.FILTER_BY_DEFAULT) < 0)
            this.filterByOptions.unshift(SharedConstants.FILTER_BY_DEFAULT);
    }
    initializePlaceHolder() {
        if (this.pageName) {
            this.filterTextPlaceHolder = `Filter ${this.pageName.toLocaleLowerCase()}`;
        }
        else {
            this.filterTextPlaceHolder = SharedConstants.FILTER_ITEMS_PLACEHOLDER;
        }
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: AppControllerService }
    ];
    static propDecorators = {
        filterByOptions: [{ type: Input }],
        filterByChanged: [{ type: Output }],
        filterTextChanged: [{ type: Output }],
        pageName: [{ type: Input }],
        initialFilterText: [{ type: Input }],
        initialFilterColumn: [{ type: Input }]
    };
};
FilterByComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-filter-by",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], FilterByComponent);
export { FilterByComponent };
